import React from 'react'

import OfflinePinIcon from '@material-ui/icons/OfflinePin'

export const OfflineIcon = props => (
  <OfflinePinIcon fontSize="small" {...props} />
)

export default OfflineIcon
